// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__tNrqe","footer":"Form_footer__1-a2z"};